import HTTP from '@/config/axios-config-erp'

const SrvPres = {
  getFormasPago(payload) {
    return HTTP.post(`/wscomun/portalinformes/formasPago`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  getListaDtos(payload) {
    return HTTP.post(`/wscomun/portalinformes/getListaDtos`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  getListaTarifas(payload) {
    return HTTP.post(`/wscomun/portalinformes/getListaTarifas`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  // AGRUPACIONES
  getAgrupaciones(payload) {
    return HTTP.post(`/wscomun/portalinformes/agrupacionesNom`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  saveAgrupacion(payload) {
    return HTTP.post(`/wscomun/portalinformes/guardaAgrupacion`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  deleteAgrupacion(payload) {
    return HTTP.post(`/wscomun/portalinformes/borraAgrupacion`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  // CARGA LAS IMAGENES DE EXPERTDRIVE
  cargarImagenes(payload) {
    return HTTP.post(`/wsedrive/getURLFile`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  // PRESUPUESTOS
  getImpresionPresupuesto(payload) {
    return HTTP.post(`/wscomun/portalinformes/impresionPresupuesto`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  acceptPresupuesto(payload) {
    return HTTP.post(`/wscomun/portalinformes/aceptarPresupuesto`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  getTipologiaPres(payload) {
    return HTTP.post(`/wscomun/portalinformes/obtenTipologiaPresupuesto`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  borrarPresupuesto(payload) {
    return HTTP.post(`/wscomun/portalinformes/borraPresupuesto`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  getListadoPresupuestos(payload) {
    return HTTP.post(`/wscomun/portalinformes/listado`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  getDetallePresupuesto(payload) {
    return HTTP.post(`/wscomun/portalinformes/detallePresupuesto`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  getNewIdPres(payload) {
    return HTTP.post(`/wscomun/portalinformes/numeroPresupuesto`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  getPresCab(payload) {
    return HTTP.post(`/wscomun/portalinformes/cabecerPresupuesto`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  savePres(payload) {
    return HTTP.post(`/wscomun/portalinformes/guardaPresupuesto`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  savePresDet(payload) {
    return HTTP.post(`/wscomun/portalinformes/guardaDetallePresupuesto`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  },
  deletePresDet(payload) {
    return HTTP.post(`/wscomun/portalinformes/borraLineaPresupuesto`, payload).then(respuesta => {
      return respuesta
    }).catch(error => {
      console.error(error)
      return error
    })
  }
}

export default SrvPres



// WEBPACK FOOTER //
// ./src/services/srv-presupuestos.js